import { blankKeyText } from '../../../constants/gridText';
import { MultipleTceFormatter } from './formatters/MultipleTceFormatter';

const TceKeyCreator = ({ value }) => {
    if (!value || value.length === 0) {
        return blankKeyText;
    }
    return MultipleTceFormatter({ value });
};

export default TceKeyCreator;
